<template>
  <ais-instant-search
    :search-client="$algolia.client"
    :search-function="searchFunction"
    :index-name="$algolia.indexPrefix + 'rendering_repository'"
    :routing="routing"
    :future="{preserveSharedStateOnUnmount: true}"
  >
    <div class="flex-col bootstrap-reset">
      <app-header key="app-header" :searchActive="searchActive" v-if="showHeader" />
      <router-view />
    </div>
  </ais-instant-search>
</template>

<script>
import components from '../algolia';
import Header from './components/Header.vue';

export default {
  components: {...components, AppHeader: Header},
  computed: {
    showHeader() {
      return this.$route.name !== 'overlay';
    }
  },
  mounted() {
    this.entryRoute = Object.freeze(this.$route);
  },
  data() {
    const indexName = this.$algolia.indexPrefix + 'rendering_repository';
    const router = this.$router;

    const stateToRoute = uiState => {
      const indexUiState = uiState[indexName] || {};

      return {
        [indexName]: {
          refinementList: indexUiState.refinementList || {},
          query: indexUiState.query || ''
        }
      };
    };

    const routeToState = routeState => {
      const {query = '', refinementList = {}} = routeState;

      return {
        [indexName]: {
          refinementList,
          query
        }
      };
    };

    // Custom Algolia router to maintain compatability with legacy filtering URLs
    const routing = {
      router: {
        read() {
          const {q: query = '', ...refinements} = JSON.parse(
            JSON.stringify(router.currentRoute.query)
          );

          let refinementList = {};
          for (const [key, value] of Object.entries(refinements)) {
            if (Array.isArray(value)) {
              refinementList[key] = value.map(val => decodeURIComponent(val));
            } else {
              refinementList[key] = [decodeURIComponent(value)];
            }
          }

          return {refinementList, query};
        },
        write(routeState) {
          window.history.replaceState({}, null, this.createURL(routeState));
        },
        createURL(routeState) {
          const indexState = routeState[indexName] || {};

          const query = indexState.query || '';
          const refinements = indexState.refinementList || {};
          let params = new URLSearchParams(query ? [['q', query]] : []);
          for (const [key, values] of Object.entries(refinements)) {
            for (const value of Array.from(values)) {
              params.append(key, value);
            }
          }
          const paramStr = params.toString().replace(/\+/g, '%20');
          if (!paramStr) return window.location.pathname;

          return `${window.location.pathname}?${paramStr}`;
        },
        onUpdate(cb) {
          this._onPopState = ({state}) => {
            const routeState = state;
            if (!Object.keys(routeState).length > 0) {
              cb(this.read());
            } else {
              cb(routeState);
            }
          };
          window.addEventListener('popstate', this._onPopState);
        },
        dispose() {
          window.removeEventListener('popstate', this._onPopState);
          this.write();
        }
      },
      stateMapping: {
        stateToRoute,
        routeToState
      }
    };

    return {
      routing,
      entryRoute: null,
      searchActive: false,
      searchFunction: helper => {
        helper.search();

        const query = helper.state.query;
        const facetsRefinements = helper.state.facetsRefinements;
        const hasFacetsRefinements = Object.values(facetsRefinements).some(
          ({length}) => length > 0
        );
        this.searchActive =
          this.$route.name === 'results' || Boolean(query) || hasFacetsRefinements;
      }
    };
  }
};
</script>
